import { createSelector } from '@ngrx/store';

import { FeatureFlagKeys, selectFeatureFlag, selectCompany, selectCurrentUser } from '@ninety/platform/state';

import { selectGuideState } from '../../_state';

export namespace GuideSelectors {
  export const selectIsGuideEnabled = createSelector(
    selectFeatureFlag(FeatureFlagKeys.gettingStartedGuide),
    selectCurrentUser,
    selectCompany,
    (flag, user, company) =>
      flag && user?.guideEnabled && !user?.guideDismissed && !company?.isCoached && !company?.implementerFree
  );

  export const selectGuideViewed = createSelector(selectCurrentUser, user => user?.guideViewed ?? false);

  export const selectIsGuideOpened = createSelector(selectGuideState, state => state.guideOpened);
  export const selectTitle = createSelector(selectGuideState, state => state.title);
  export const selectSubtitle = createSelector(selectGuideState, state => state.subtitle);
  export const selectCompletionPercentage = createSelector(selectGuideState, state => state.completionPercentage);

  export const selectPhases = createSelector(selectGuideState, state => state.phases);
  export const selectSelectedPhase = createSelector(selectGuideState, state => state.selectedPhase);
}
